import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["data-test", "className", "name", "disabled", "autoComplete", "label", "optional", "options", "value", "placeholder", "onChange", "onBlur", "onFocus", "error", "maxWidth", "wrapperWidth", "marginBottom"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import { ChevronIcon } from '@sainsburys-tech/bolt-icons';
import * as Styled from './Select.styles';

var Select = /*#__PURE__*/function (_React$Component) {
  _inherits(Select, _React$Component);

  var _super = _createSuper(Select);

  function Select() {
    _classCallCheck(this, Select);

    return _super.apply(this, arguments);
  }

  _createClass(Select, [{
    key: "renderDefaultOption",
    value: function renderDefaultOption() {
      return /*#__PURE__*/React.createElement("option", {
        value: "",
        disabled: true
      }, this.props.placeholder);
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var options = this.props.options;
      if (!options) return null;
      return options.map(function (option) {
        return /*#__PURE__*/React.createElement("option", {
          key: option.title,
          value: option.value,
          selected: option.selected,
          disabled: option.disabled
        }, option.title);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataTest = _this$props['data-test'],
          className = _this$props.className,
          name = _this$props.name,
          disabled = _this$props.disabled,
          autoComplete = _this$props.autoComplete,
          label = _this$props.label,
          optional = _this$props.optional,
          options = _this$props.options,
          value = _this$props.value,
          placeholder = _this$props.placeholder,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          error = _this$props.error,
          maxWidth = _this$props.maxWidth,
          wrapperWidth = _this$props.wrapperWidth,
          marginBottom = _this$props.marginBottom,
          props = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement(Styled.Wrapper, {
        className: className,
        marginBottom: marginBottom,
        wrapperWidth: wrapperWidth
      }, label && /*#__PURE__*/React.createElement(Styled.Label, {
        id: "".concat(dataTest, "-").concat(name, "-label"),
        htmlFor: name,
        hasSecondLine: !!error
      }, label, optional && /*#__PURE__*/React.createElement("span", null, optional)), error && /*#__PURE__*/React.createElement(Styled.Hint, {
        error: true,
        "data-test": "".concat(dataTest, "-error"),
        id: "".concat(name, "-error-message"),
        role: "alert"
      }, error), /*#__PURE__*/React.createElement(Styled.SelectRow, {
        maxWidth: maxWidth
      }, /*#__PURE__*/React.createElement(Styled.Select, _extends({
        "data-test": dataTest,
        id: name,
        name: name,
        disabled: disabled,
        autoComplete: autoComplete,
        options: options,
        value: value || '',
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        error: error,
        "aria-describedby": error ? "".concat(name, "-error-message") : "".concat(dataTest, "-").concat(name, "-label")
      }, props), placeholder && this.renderDefaultOption(), this.renderOptions()), /*#__PURE__*/React.createElement(Styled.SelectArrow, null, /*#__PURE__*/React.createElement(ChevronIcon, {
        dir: "down",
        width: "24",
        height: "24"
      }))));
    }
  }]);

  return Select;
}(React.Component);

Select.propTypes = {
  /**
   * Specify an optional className to be added to your Select
   */
  className: PropTypes.string,

  /**
   * Specify an optional data-test attribute to be added for e2e testing
   */
  'data-test': PropTypes.string,

  /**
   * Specify the Select name to reference it in form handling
   */
  name: PropTypes.string,

  /**
   * Specify whether the Select should be disabled
   */
  disabled: PropTypes.bool,

  /**
   * Specify whether browser autocomplete should be enabled
   */
  autoComplete: PropTypes.string,

  /**
   * Specify whether the Input should have label text
   */
  label: PropTypes.string,

  /**
   * Specify an optional "optional identifier" be added to the label
   */
  optional: PropTypes.string,

  /**
   * The select value passed in from the parent component that handles state
   */
  value: PropTypes.string,

  /**
   * The instructional text to show as the first (disabled) option
   */
  placeholder: PropTypes.string,

  /**
   * The onChange function passed in from the parent component that handles state
   */
  onChange: PropTypes.func,

  /**
   * The onBlur function passed in from the parent component that handles state
   */
  onBlur: PropTypes.func,

  /**
   * The onFocus function passed in from the parent component that handles state
   */
  onFocus: PropTypes.func,

  /**
   * Specify the error message to be shown
   */
  error: PropTypes.string,

  /**
   * Maximum wrapper width to override the default 100% width
   */
  maxWidth: PropTypes.string,

  /**
   * Wrapper width to override the default 100% width
   * Use this when positioning multiple selects inline
   */
  wrapperWidth: PropTypes.string,

  /**
   * Bottom margin to be applied to the Select
   */
  marginBottom: PropTypes.number
};
Select.defaultProps = {
  'data-test': 'select',
  name: '',
  disabled: false,
  autoComplete: 'on',
  label: '',
  optional: '',
  value: '',
  placeholder: 'Please select',
  onChange:
  /* istanbul ignore next */
  function onChange() {},
  onBlur:
  /* istanbul ignore next */
  function onBlur() {},
  onFocus:
  /* istanbul ignore next */
  function onFocus() {},
  error: '',
  marginBottom: 25
};
export default Select;